import script from "./vehicles-found.vue?vue&type=script&setup=true&lang=ts"
export * from "./vehicles-found.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__